export const AppRoutes = {
  Dashboard: '/',
  FNAs: '/need-analyses',
  ErrorPage: '/error',
  Clients: '/clients',
  LegalEntities: '/legal-entities',
  NaturalPersons: '/natural-persons',
  // Add "-page" to avoid conflict with the API routes (don't ask why API api routes are not prefixed with "/api")
  Quotes: '/quotes-page',
  Reports: '/reports-page',
};
